import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'alumni-service-list',
  name: '服务大厅',
  icon: '服',
  group: '校友会组件',
  description: '展示校友卡、返校预约、互助服务等服务入口。',
  defaultProps: {
    title: '服务大厅',
    limit: 6
}
}
